export const FETCH_OMNITRON_ORDERS_PENDING = 'FETCH_OMNITRON_ORDERS_PENDING';
export const FETCH_OMNITRON_ORDERS_REJECTED = 'FETCH_OMNITRON_ORDERS_REJECTED';
export const FETCH_OMNITRON_ORDERS_FULFILLED =
  'FETCH_OMNITRON_ORDERS_FULFILLED';



// WEBPACK FOOTER //
// ./src/constants/kapidaConstants/omnitronOrders.js